// src/index.js
import AudioBlockEdit from './Edit';
import AudioBlockView from './View';
import audioSVG from '@plone/volto/icons/audio.svg';

const applyConfig = (config) => {
  config.blocks.blocksConfig.audioBlock = {
    id: 'audioBlock',
    title: 'Audio',
    icon: audioSVG,
    group: 'media',
    edit: AudioBlockEdit,
    view: AudioBlockView,
    restricted: false,
    mostUsed: true,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
